






























































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ReturObatItemTable extends Vue {
  @Prop({ default: () => [] }) items!: any[];
  @Prop({ default: false }) readonly!: boolean;
  @Prop({ default: null }) returId!: number | null;

  get tableHeaders() {
    const headers = [
      { text: "No", value: "no", width: "40px", sortable: false },
      { text: "Kategori", value: "kategori", width: "90px" },
      { text: "Nama Item", value: "nama_item" },
      { text: "Kekuatan", value: "kekuatan_sediaan", width: "90px" },
      { text: "Satuan", value: "satuan", width: "70px" },
      { text: "Jumlah", value: "jumlah_retur", width: "70px" },
      { text: "Kondisi", value: "kondisi", width: "100px" },
      { text: "Keterangan", value: "keterangan", width: "120px" },
      { text: "Harga", value: "harga", width: "100px" },
    ];

    if (!this.readonly) {
      headers.push({ text: "Aksi", value: "actions", width: "80px", sortable: false });
    }

    return headers;
  }

  kategoriColor(k: string) {
    const map: Record<string, string> = {
      obat: "blue",
      cairan: "teal",
      alkes: "brown",
      narkotika: "red",
      nutrisi: "purple",
    };
    return map[k] || "grey";
  }

  kategoriLabel(k: string) {
    const map: Record<string, string> = {
      obat: "Obat",
      cairan: "Cairan",
      alkes: "Alkes",
      narkotika: "Narkotika",
      nutrisi: "Nutrisi",
    };
    return map[k] || k;
  }

  kondisiColor(k: string) {
    const map: Record<string, string> = {
      utuh: "green",
      terbuka_layak: "orange",
      terbuka_tidak_layak: "red",
      expired: "red darken-3",
      rusak: "red darken-1",
    };
    return map[k] || "grey";
  }

  kondisiLabel(k: string) {
    const map: Record<string, string> = {
      utuh: "Utuh",
      terbuka_layak: "Terbuka (Layak)",
      terbuka_tidak_layak: "Terbuka (Tidak Layak)",
      expired: "Expired",
      rusak: "Rusak",
    };
    return map[k] || k;
  }

  formatCurrency(val: number) {
    return "Rp " + val.toLocaleString("id-ID");
  }
}
